import { cloudFunction } from '../parse';

export const deleteUnit = (id: string) => {
  return cloudFunction('deleteUnit', { id });
};

export const updateUnit = (params: any) => {
  return cloudFunction('updateUnit', params);
};

export const createUnit = (params: any) => {
  return cloudFunction('createUnit', params);
};

export const fetchUnitDetails = (id: string) => {
  return cloudFunction('fetchUnitDetails', { id });
};
